import { Badge } from "@/components/ui/badge"
import { useT } from "@/i18n/provider"
import type { RunStatus } from "@/lib/types"

const RUN_VARIANTS: Record<RunStatus, "default" | "secondary" | "destructive" | "success" | "warning"> = {
  queued: "secondary",
  running: "secondary",
  succeeded: "success",
  failed: "destructive",
  cancelled: "secondary",
  max_iterations: "warning",
  timeout: "warning",
  abandoned: "destructive",
}

// Maps each status to its key suffix under `common.status.run.*` (camelCase, unlike the
// snake_case status values themselves).
export const RUN_STATUS_LABEL_KEYS: Record<RunStatus, string> = {
  queued: "queued",
  running: "running",
  succeeded: "succeeded",
  failed: "failed",
  cancelled: "cancelled",
  max_iterations: "maxIterations",
  timeout: "timeout",
  abandoned: "abandoned",
}

export function RunStatusBadge({ status }: { status: RunStatus }) {
  const t = useT()
  return (
    <Badge variant={RUN_VARIANTS[status] ?? "secondary"}>
      {t(`common.status.run.${RUN_STATUS_LABEL_KEYS[status] ?? status}`)}
    </Badge>
  )
}

export function ConnectionStatusBadge({
  status,
  enabled,
}: {
  status: "unknown" | "ok" | "error"
  enabled: boolean
}) {
  const t = useT()
  if (!enabled) return <Badge variant="secondary">{t("common.status.disabled")}</Badge>
  if (status === "ok") return <Badge variant="success">{t("common.status.connection.connected")}</Badge>
  if (status === "error") {
    return <Badge variant="destructive">{t("common.status.connection.unreachable")}</Badge>
  }
  return <Badge variant="secondary">{t("common.status.connection.notChecked")}</Badge>
}
